module.exports = __webpack_public_path__ + "media/icons/shopping_bag-77008932.svg";